import { call, put, select, takeEvery } from 'redux-saga/effects';
import { selectBannerToDisplay } from 'features/Banners/Banners.reducer';
import { setPagePromotion } from 'redux/modules/page';
import { loadActivePromotion } from 'redux/saga/helpers/promotions';
import { cmsAddBanner } from './CmsBanner.reducer';

export function* loadCmsBannerSaga() {
  const currentBanner = yield select(selectBannerToDisplay, 'announcement');
  if (!currentBanner) {
    yield put(cmsAddBanner());
  }
}

export function* doLoadActivePromotionForBanner(client, { data: promoAlias }) {
  yield call(loadActivePromotion, client, promoAlias);
}

export function* watchPagePromotionForBanner(client) {
  yield takeEvery(setPagePromotion().type, doLoadActivePromotionForBanner, client);
}
